export interface IEneatipo {
  id: number;
  nombre: string;
  rasgos: { tipo: TipoRasgo; descripcion: string }[];
}

export enum TipoRasgo {
  descriptivo,
  bueno,
  malo,
  informativo,
}
